import React from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

function Footer(props) {
  const RequestHelp = async () => {
    await props.AxiosRequest("/api/companies/request-help");
  };
  return (
    <footer className="footer" style={{ padding: "0px" }}>
      <div className="container-fluid">
        <div className="row text-muted">
          <div className="col-8 text-start">
            <ul className="list-inline">
              <li className="list-inline-item">
                <Link reloadDocument className="text-muted" to="https://firmtamer.com/privacy-policy/" target="_blank">
                  Privacy &amp; Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-4 text-end">
            <p className="mb-0">
              © 2021 - {dayjs().format("YYYY") + " "}
              <Link to="#" className="text-muted" onClick={RequestHelp}>
                FirmTamer
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
